import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

/**
 * The old Trades page, kept as a redirect so bookmarks and the "g r" shortcut still land:
 * the trade log is the History view of Positions, and the signals log is a sheet on the Overview.
 */
export const Route = createFileRoute('/_app/trades')({
  validateSearch: z.object({
    tab: z.enum(['trades', 'signals']).optional().catch(undefined),
    decision: z.enum(['copied', 'skipped', 'failed']).optional().catch(undefined),
  }),
  beforeLoad: ({ search }) => {
    if (search.tab === 'signals') {
      throw redirect({ to: '/', search: { signals: search.decision ?? 'all' }, replace: true });
    }
    throw redirect({ to: '/positions', search: { view: 'history' }, replace: true });
  },
});
